import { render, staticRenderFns } from "./fourth.vue?vue&type=template&id=28c8247c&scoped=true"
import script from "./fourth.vue?vue&type=script&lang=js"
export * from "./fourth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c8247c",
  null
  
)

export default component.exports